export class Contact {
    public name:string;
    public email: string;
    public phone: string;
    public freeText: string;
    public shoppingCart: any;
    public dateCreated?: Date;
}
